import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import TableUsers from "./TableUsers/TableUsers";
import toast from "react-hot-toast";
import { getAllUsers } from "../../services/users/userService";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/Loading/Loading";
import { setListAllUsers } from "../../redux/slice/usersSlice";
import { handleError } from "../../utils/handleError";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PieGraphicUsers from "./PieGraphicsUsers";
import BarChartUsers from "./BarChartusers";
import CreateUserModal from "./ModalUser";

const Users = () => {
  const { listAllUsers } = useSelector((state) => state.usersReducer);
  const [loading, setLoading] = useState(true);
  const [showModalUser, setShowModalUser] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getListUsers = async () => {
      try {
        setLoading(true);
        //Aqui se hace la peticion a la api de lista de usuarios
        const responseListUsers = await getAllUsers();
        dispatch(setListAllUsers({ listAllUsers: responseListUsers }));
        // console.log("Todos los usuarios", responseListUsers);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        dispatch(setListAllUsers({ listAllUsers: [] }));
        const { message } = handleError(error);
        // console.log("error:", error);

        toast.error(`No pudimos obtener los usuarios.  \n ${message}`);
      }
    };
    getListUsers();
  }, [dispatch]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Loading loading={loading} />
      <CreateUserModal
        open={showModalUser}
        setOpen={setShowModalUser}
        setLoading={setLoading}
        type={"user"}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h5">Usuarios</Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<PersonAddIcon />}
          onClick={() => {
            setShowModalUser(true);
          }}
        >
          Agregar usuario
        </Button>
      </Box>
      <TableUsers setLoading={setLoading} rows={listAllUsers ?? []} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          flexWrap: "wrap",
          justifyContent: "space-around",
          gap: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Origen de Registro</Typography>
          <PieGraphicUsers />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Estatus de las cuentas</Typography>
          <BarChartUsers />
        </Box>
      </Box>
    </Box>
  );
};

export default Users;
